import React from 'react'
import XIcon from '../../images/svg/XIcon'

type ClearableFieldWrapperProps = {
  showClear: boolean
  hasError?: boolean | undefined
  onClear: (event: React.MouseEvent<HTMLButtonElement>) => void
  label?: string | null
  // 'top-right'  -> icon in top-right corner (good for html textarea elements)
  // 'middle-right' -> icon centered vertically (good for html input elements)
  variant?: 'top-right' | 'middle-right'
}

export default function ClearableFieldWrapper({
  showClear,
  hasError = false,
  onClear,
  label,
  variant = 'middle-right',
  children,
}: React.PropsWithChildren<ClearableFieldWrapperProps>) {
  const iconColorClasses = hasError
    ? 'text-red-400 hover:text-red-600 dark:text-red-300 dark:hover:text-red-200'
    : 'text-gray-400 hover:text-gray-600 dark:text-slate-400 dark:hover:text-slate-200'

  const verticalPositionClasses =
    variant === 'top-right' ? 'top-2' : 'top-1/2 -translate-y-1/2 transform'

  return (
    <div className="relative">
      {children}
      {showClear && (
        <button
          type="button"
          onClick={onClear}
          aria-label={label ? `Clear ${label}` : 'Clear input'}
          className={[
            `absolute right-2 ${verticalPositionClasses} flex items-center justify-center rounded-full`,
            'focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900',
          ].join(' ')}
        >
          <XIcon className={`w-4 h-4 ${iconColorClasses}`} />
        </button>
      )}
    </div>
  )
}
